import { render } from "./MMyFavorite.vue?vue&type=template&id=054f7d1a&scoped=true"
import script from "./MMyFavorite.vue?vue&type=script&lang=js"
export * from "./MMyFavorite.vue?vue&type=script&lang=js"

import "./MMyFavorite.vue?vue&type=style&index=0&id=054f7d1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054f7d1a"]])

export default __exports__